import type { Audience } from '@openx/types/gqlTypes.ts';
import type { ConstValues } from '@openx/types/helpers.ts';
import { CriteriaDimension, SortDirection } from '@openx/types/tableCriteria.ts';
import { AudienceStatus } from '@openx/types/targeting/audience.ts';
import { TABLE_PAGE_SIZE } from '../../../config.ts';
import type { DefaultTableCriteria } from '../../../utils/useListCriteria.ts';
export const ExportingStatus = {
  INIT: 'init',
  EXPORT_WORKER_DONE: 'export_worker_done',
  EXPORT_DOWNLOADING: 'export_downloading',
  EXPORT_DOWNLOADING_DONE: 'export_downloading_done',
  EXPORT_PROCESSING: 'export_processing',
  EXPORT_PROCESSING_DONE: 'export_processing_done',
} as const;
export type ExportingStatus = ConstValues<typeof ExportingStatus>;

export const ACTIVE_STATUSES = [AudienceStatus.EXPORTED] as const;

export const EDITABLE_STATUSES = [
  AudienceStatus.PUBLISH_FAILED,
  AudienceStatus.ACTIVATE_FAILED,
  AudienceStatus.EXPORT_FAILED,
  AudienceStatus.EXPORTED,
  AudienceStatus.EXPIRED,
];

export const FAILED_STATUSES = [
  AudienceStatus.PUBLISH_FAILED,
  AudienceStatus.ACTIVATE_FAILED,
  AudienceStatus.EXPORT_FAILED,
  AudienceStatus.EXPIRE_FAILED,
] as const;

export const PROCESSING_STATUSES = [
  AudienceStatus.PUBLISHING,
  AudienceStatus.ACTIVATED,
  AudienceStatus.EXPORTING,
] as const;

export const FORBIDDEN_STATUSES = [AudienceStatus.EXPIRED, AudienceStatus.EXPIRING] as const;

export type TooltipContentReachSectionType = ConstValues<typeof TooltipContentReachSectionType>;
export const TooltipContentReachSectionType = {
  SOURCE_PROVIDED_COUNT: 'source_provided_count',
  SOURCE_MATCHED_COUNT: 'source_matched_count',
  COOKIES: 'cookie',
  DEVICES: 'device',
  TOTAL_IDLS: 'idl',
  CONNECTED_TV_DEVICES: 'ctv',
  IPS: 'ip',
  ID5: 'id5',
} as const;

export const audiencesDefaultCriteria: DefaultTableCriteria<'audiences'> = {
  [CriteriaDimension.FILTERS]: {
    phrase: '',
  },
  [CriteriaDimension.PAGINATION]: {
    pageNumber: 1,
    pageSize: TABLE_PAGE_SIZE,
    totalCount: 0,
  },
  [CriteriaDimension.SORT]: {
    column: 'updated_date' satisfies keyof Audience,
    direction: SortDirection.DESC,
    sortableColumns: [
      'name',
      'status',
      'addressable_reach',
      'direct_audience_provider',
      'account',
      'updated_date',
    ] satisfies (keyof Audience)[],
    valuePath: {
      account: ['name'],
    },
  },
};
